<ng-container *ngIf="privacyPolicy$ | async as privacyPolicy">
    <div class="m-3" [innerHTML]="privacyPolicy.text"></div>
</ng-container>
